import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import oktaAuth from '../../auth/oktaAuth';
import './TopBar.css';

function TopBar({ userInitials = 'BR', currentUser, onUserUpdate }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    oktaAuth.signOut({ postLogoutRedirectUri: `${window.location.origin}/login` });
  };

  return (
    <div className="top-bar">
      <img src="/csq_logo.png" alt="CSQ Logo" className="csq-logo" />
      <div className="user-menu" ref={menuRef}>
        <div className="user-logo" onClick={() => setMenuOpen(o => !o)}>
          {userInitials}
        </div>
        {menuOpen && (
          <div className="user-dropdown">
            <button className="user-dropdown-item" onClick={() => { setMenuOpen(false); navigate('/profile'); }}>
              Profile
            </button>
            <button className="user-dropdown-item" onClick={() => { setMenuOpen(false); navigate('/admin'); }}>
              Admin
            </button>
            <div className="user-dropdown-divider" />
            <button className="user-dropdown-item" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopBar;
